import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const OrganizacionContext = createContext();

export const useOrganizacion = () => {
  const context = useContext(OrganizacionContext);
  if (!context) {
    throw new Error('useOrganizacion debe usarse dentro de OrganizacionProvider');
  }
  return context;
};

export const OrganizacionProvider = ({ children }) => {
  const [config, setConfig] = useState({
    nombre_organizacion: 'Sistema de Evaluación 360°',
    color_primario: '#3B82F6',
    color_secundario: '#1E40AF',
    mostrar_logo: false,
    logo_filename: null
  });
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadConfig = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001/api';
      const response = await axios.get(`${API_URL}/configuracion/organizacion`);
      
      if (response.data.success) {
        const configData = response.data.data;
        setConfig(configData);
        
        // Cargar logo si existe
        if (configData.logo_filename && configData.mostrar_logo) {
          setLogoUrl(`${API_URL}/configuracion/organizacion/logo?t=${Date.now()}`);
        } else {
          setLogoUrl(null);
        }
      }
    } catch (error) {
      console.error('Error al cargar configuración de organización:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadConfig();
  }, []);

  const reloadConfig = () => {
    loadConfig();
  };

  return (
    <OrganizacionContext.Provider value={{ config, logoUrl, loading, reloadConfig }}>
      {children}
    </OrganizacionContext.Provider>
  );
};
